import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getRandomColor } from '../../utils/utils';
import { loginAction, logoutAction, userAuthzLoaded } from '../rootAction';
import { RootState } from '../store';

export interface UserInfoType {
  name: string;
  email: string;
  givenname: string;
  surname: string;
  age: number;
  userId: string;
  userKind: number;
  status: string;
}

export interface UserState {
  user: UserInfoType | null;
  userAuthzLoadedAt: string | null;
  profileAvtarBGColor: string;
  email: string | null;
}

const initialState: UserState = {
  user: null,
  userAuthzLoadedAt: null,
  profileAvtarBGColor: getRandomColor(),
  email: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserInfoType>) {
      sessionStorage.setItem('isAuthenticated', 'true');
      state.user = action.payload;
    },
    clearUser(state) {
      sessionStorage.removeItem('isAuthenticated');
      state.user = null;
    },
    setUserEmail(state, action: PayloadAction<string | null>) {
      state.email = action.payload;
    },
    clearUserEmail(state) {
      state.email = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginAction, (state) => {
      state.profileAvtarBGColor = getRandomColor();
    });

    builder.addCase(logoutAction, (state) => {
      state.user = null;
      sessionStorage.removeItem('isAuthenticated');
    });

    builder.addCase(userAuthzLoaded, (state, action) => {
      state.userAuthzLoadedAt = action.payload;
    });
  },
});

export const { setUser, setUserEmail, clearUser, clearUserEmail } =
  userSlice.actions;
export const selectUser = (state: RootState) => state.user?.user;
export const isAuthenticated = () =>
  sessionStorage.getItem('isAuthenticated') === 'true';
export const selectUserAuthzLoadedAt = (state: RootState) =>
  state.user.userAuthzLoadedAt;
export const getProfileAvtarBGColor = (state: RootState) =>
  state.user.profileAvtarBGColor;
export const selectEmail = (state: RootState) => state.user.email;

export default userSlice.reducer;
